import { render } from "./PortfolioSection.vue?vue&type=template&id=36e63e80"
import script from "./PortfolioSection.vue?vue&type=script&lang=js"
export * from "./PortfolioSection.vue?vue&type=script&lang=js"

import exportComponent from "/Users/content/Documents/Biggie/triple_palm/photography-landing-page-master/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__